// extracted by mini-css-extract-plugin
module.exports = {"tabs":"e_vx","title":"e_wx","list":"e_xx","listActive":"e_yx","leftList":"e_zx","rightList":"e_Ax","grid":"e_Bx"};